import { VerifyEmailForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

export function VerifyEmailPage() {
  return (
    <AuthLayout>
      <VerifyEmailForm />
    </AuthLayout>
  );
}
